<template>
    <div class="rental-company-list">
        <heading title="Global Rentals" tag="rental-company-list-title">
            <b-button variant="primary"
                      :to="{name:'rentalCompanyCreate'}">
                Create Rental Company
                <b-icon-plus-square/>
            </b-button>
        </heading>
        <data-table ref="dataTable"
                    persist-name="rental-company-filter"
                    :show-filters="true"
                    :show-pager="true"
                    :get-items="getEntries"
                    v-model="filters"
                    :fields="fields">
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key === 'actions'" class="action-buttons d-flex">
                    <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                            v-if="slotProps.row.item.status === 'UNAPPROVED'"
                            v-on:click="approve(slotProps.row.item)">
                        Approve
                    </button>
                    <button class="btn btn-danger btn-sm mr-2 btn-icon"
                            v-if="slotProps.row.item.status === 'APPROVED'"
                            v-on:click="unapprove(slotProps.row.item)">
                        Unapprove
                    </button>
                </div>
                <div v-else-if="slotProps.row.field.key === 'address'">
                    <template>
                        {{ formatAddress(slotProps.row.item) }}
                    </template>
                </div>
                <div v-else-if="slotProps.row.field.key === 'notes'">
                    <button @click="showNoteModal(slotProps.row.item)">
                        <b-icon-pencil-square />
                    </button>
                    <text-popover :id="`note-popover-${slotProps.row.item.id}`" class="d-inline ml-1">
                        {{slotProps.row.item.notes}}
                    </text-popover>
                </div>
                <div v-else-if="slotProps.row.field.key === 'status'">
                    <b-badge v-if="slotProps.row.item.status === 'APPROVED'" variant="primary">
                        Approved
                    </b-badge>
                    <b-badge v-if="slotProps.row.item.status === 'UNAPPROVED'" variant="danger">
                        Unapproved
                    </b-badge>
                </div>
            </template>
        </data-table>

        <b-modal id="note-modal" @ok="saveNote">
            <b-form-group label="Note">
                <b-textarea v-model="notetext" />
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>

import RentalCompany from '@/models/RentalCompany'
import TextPopover from '@/components/TextPopover'

export default {
    name: 'RentalCompanyList',
    components: { TextPopover },
    data () {
        return {
            fields: [
                { key: 'name', sortable: true, label: 'Name' },
                { key: 'email', sortable: true, label: 'Email' },
                { key: 'address', sortable: true, label: 'Address' },
                { key: 'phone', sortable: true, label: 'Phone' },
                { key: 'notes', sortable: false, label: 'Notes' },
                { key: 'status', sortable: true, label: 'Status' },
                { key: 'actions', sortable: true, label: 'Actions' },
            ],
            filters: {
                name: {
                    field: 'name',
                    label: 'Name',
                    type: 'string'
                },
                address: {
                    field: 'address',
                    label: 'Address',
                    type: 'string'
                },
                status: {
                    field: 'status',
                    label: 'Status',
                    type: 'select',
                    options: [
                        { value: 'APPROVED', text: 'Approved' },
                        { value: 'UNAPPROVED', text: 'Unapproved' }
                    ]
                },
            },
            notetext: '',
            modelItem: null
        }
    },
    methods: {
        getEntries (listParams) {
            return this.$api.getItems(this, 'rental-company', this.filters, listParams)
        },
        approve (item) {
            item.status = 'APPROVED'
            this.$api.updateItem(this, 'rental-company', item).then((response) => {
                this.$refs.dataTable.refresh()
            })
        },
        unapprove (item) {
            item.status = 'UNAPPROVED'
            this.$api.updateItem(this, 'rental-company', item).then((response) => {
                this.$refs.dataTable.refresh()
            })
        },
        formatAddress (item) {
            return RentalCompany.formatAddress(item)
        },
        showNoteModal(item) {
            this.modalItem = item
            this.notetext = item.notes
            this.$bvModal.show('note-modal')
        },
        saveNote() {
            const item = this.modalItem
            item.notes = this.notetext
            this.$api.updateItem(this, 'rental-company', item).then((response) => {
                this.$refs.dataTable.refresh()
            })
        }
    }
}
</script>

<style scoped>

</style>